import React, { useEffect, useState } from "react";
import attendanceApi from "../../apis/attendanceApi";

// A teacher's Home: today's classes, each one tap from its check-in sheet.
// Checking students in is the one thing a group-class teacher does in the
// app, and it used to have no link from their login at all. Renders nothing
// until there is a class to show.

const card = {
  background: "#fff", border: "1px solid #E0E0E0", borderRadius: 16,
  boxShadow: "0 4px 6px rgba(0,0,0,.05)", padding: "18px 20px", marginBottom: 16,
};
const row = {
  display: "flex", alignItems: "center", gap: 14, padding: "12px 0",
  borderTop: "1px solid #F1F2F4", textDecoration: "none", color: "inherit",
};
const pill = {
  marginLeft: "auto", flexShrink: 0, fontSize: 13, fontWeight: 700, color: "#fff",
  background: "#1a1a1a", borderRadius: 140, padding: "9px 16px", whiteSpace: "nowrap",
};

// A class is at 7 PM at the studio wherever the phone is.
const timeAt = (iso, timeZone) =>
  iso ? new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", ...(timeZone ? { timeZone } : {}) }) : "";
const clockLabel = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map((n) => parseInt(n, 10));
  return `${h % 12 === 0 ? 12 : h % 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};
const dayLabel = (ymd) =>
  new Date(`${ymd}T12:00:00`).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });

const CheckInToday = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    attendanceApi.today()
      .then((res) => { if (alive) setData(res || {}); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!data) return null;
  const sessions = (data.sessions || []).filter((s) => !s.attributes.cancelled);
  const next = data.next_class;
  if (sessions.length === 0 && !next) return null;

  return (
    <div style={card} data-testid="check-in-today">
      <div style={{ fontSize: 17, fontWeight: 700, color: "#1a1a1a", marginBottom: sessions.length ? 8 : 4 }}>
        {sessions.length ? "Your classes today" : "Your next class"}
      </div>

      {sessions.map((s) => {
        const a = s.attributes;
        const roster = a.roster || [];
        const marked = roster.filter((r) => r.attendance_status === "present" || r.attendance_status === "late").length;
        return (
          <a key={s.id} href={`/class_sessions/${s.id}`} style={row}>
            <div style={{ minWidth: 72, fontSize: 15, fontWeight: 700 }}>{timeAt(a.start_at, a.time_zone)}</div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis" }}>{a.class_name}</div>
              <div style={{ fontSize: 13, color: "#666666" }}>
                {roster.length === 0
                  ? "No one on the list yet"
                  : `${marked} of ${roster.length} checked in`}
              </div>
            </div>
            <span style={pill}>Check in</span>
          </a>
        );
      })}

      {sessions.length === 0 && next && (
        <a href={`/attendance/today?date=${next.date}`} style={{ ...row, borderTop: "none", paddingTop: 0 }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 600 }}>{next.class_name}</div>
            <div style={{ fontSize: 13, color: "#666666" }}>
              {dayLabel(next.date)}{next.start_time ? ` at ${clockLabel(next.start_time)}` : ""}
            </div>
          </div>
          <span style={{ ...pill, background: "#fff", color: "#1a1a1a", border: "1px solid #1a1a1a" }}>Open</span>
        </a>
      )}
    </div>
  );
};

export default CheckInToday;
